export default __webpack_public_path__ + "static/media/charity.f9a907d4.jpg";